module.exports = __webpack_public_path__ + "static/media/shape2_3.807e8d93.obj";